import React from "react";

import { Row, Stack } from "react-bootstrap";

import classNames from "classnames";

import { ResaleFragment } from "@api/graphql";
import { ExternalRoles } from "@roles";

import { useIsAuthUserAllowed } from "../permission_control/ProtectedComponent";
import { PaymentStatusBadge } from "../table/PaymentStatusBadge";

interface PaymentDetailsProps {
  resale: ResaleFragment;
}

export const PaymentBadgeDrawer = ({ resale }: PaymentDetailsProps) => {
  const isExternalUser = useIsAuthUserAllowed(ExternalRoles);
  return (
    <Stack gap={4} className={classNames("payment-details", "col-md-10")}>
      <Row>
        <span className="h5 mb-0">Finance status</span>
      </Row>
      <Row>
        <div className="w-auto">
          <PaymentStatusBadge
            cellValue={resale.payment_status}
            isExternalUser={isExternalUser}
            creditNoteReason={resale.credit_note_reason}
          />
        </div>
      </Row>
    </Stack>
  );
};
